// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__taiD1","productName":"Table_productName__1I3Eg"};